import template from "./template.hbs";

// ---------------- Закладки ----------------
const bookmarkInput = document.getElementById("bookmarkInput");
const addBookmarkBtn = document.getElementById("addBookmarkBtn");
const bookmarkList = document.getElementById("bookmarkList");

let bookmarks = JSON.parse(localStorage.getItem("bookmarks")) || [];

function saveBookmarks() {
  localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
}

function renderBookmarks() {
  bookmarkList.innerHTML = "";

  bookmarks.forEach((url, index) => {
    const li = document.createElement("li");

    const link = document.createElement("a");
    link.href = url;
    link.textContent = url;
    link.target = "_blank";

    const deleteBtn = document.createElement("button");
    deleteBtn.textContent = "X";
    deleteBtn.classList.add("delete");

    deleteBtn.addEventListener("click", () => {
      bookmarks.splice(index, 1);
      saveBookmarks();
      renderBookmarks();
    });

    link.addEventListener("dblclick", () => {
      const newUrl = prompt("Новий URL:", url);

      if (newUrl) {
        bookmarks[index] = newUrl;
        saveBookmarks();
        renderBookmarks();
      }
    });

    li.append(link, deleteBtn);
    bookmarkList.appendChild(li);
  });
}

addBookmarkBtn.addEventListener("click", () => {
  const value = bookmarkInput.value.trim();

  if (!value) return;

  bookmarks.push(value);

  saveBookmarks();
  renderBookmarks();

  bookmarkInput.value = "";
});

renderBookmarks();

// ---------------- Форма ----------------
const usernameInput = document.getElementById("username");
const passwordInput = document.getElementById("password");
const saveFormBtn = document.getElementById("saveBtn");

function loadFormData() {
  const data = JSON.parse(localStorage.getItem("formData"));

  if (!data) return;

  usernameInput.value = data.username || "";
  passwordInput.value = data.password || "";
}

saveFormBtn.addEventListener("click", () => {
  const formData = {
    username: usernameInput.value,
    password: passwordInput.value,
  };

  localStorage.setItem("formData", JSON.stringify(formData));
});

loadFormData();

// ---------------- Товари ----------------
const products = [
  {
    name: "Laptop",
    price: 1200,
    description: "Powerful laptop",
  },
  {
    name: "Phone",
    price: 800,
    description: "Smartphone",
  },
  {
    name: "Headphones",
    price: 200,
    description: "Noise cancelling",
  },
];

const productsContainer = document.getElementById("products");
const searchInput = document.getElementById("search");

function renderProducts(data) {
  productsContainer.innerHTML = template({
    products: data,
  });
}

searchInput.addEventListener("input", (e) => {
  const value = e.target.value.toLowerCase();

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(value),
  );

  renderProducts(filteredProducts);
});

renderProducts(products);
